import { getStepConfig } from './stepConfig';

class StepController {
	constructor() {
		// ensures singleton
		if (StepController._instance) {
			return StepController._instance;
		}
		StepController._instance = this;
	}

	updateSteps({ state, currentStep, labels, isDesktop }) {
		// set internal fields
		this.labels = labels;
		this.oemCount = 1; // defaults to 1
		this.currentStep = currentStep;
		this.currentStepIdx = 0;
		this.currentStepNum = 1;
		this.hasPackages = false;
		this.isDesktop = isDesktop;

		this.state = state;
		this.currentStep = currentStep;

		// get vehicle configuration data from redux state
		const {
			vehicleConfiguration: {
				make = '',
				model = '',
				trimName = '',
				options = {}
			},
			selectedTrimData = {},
			accountData: { accountFranchises = [] },
			rootDir
		} = this.state;
		const { drivetrain = {}, cab, paint } = options;

		this.oemCount = accountFranchises.length;

		// update the step config each time redux state changes
		this.stepConfig = getStepConfig(
			this.labels,
			this.oemCount,
			make.toLowerCase(),
			model.toLowerCase(),
			trimName,
			drivetrain.value,
			cab,
			paint.value,
			rootDir
		);

		this.currentStepIdx = this.stepConfig.steps.findIndex(
			(step) => step.name === this.currentStep
		);
		this.currentStepObj = this.stepConfig.steps[this.currentStepIdx];
		this.currentStepNum = this.currentStepIdx + 1;
		this.hasPackages = selectedTrimData?.packages?.length;

		// update local storage
		this.setLsVehicleConfig();
	}

	getNextStep() {
		// skip packages screen if no packages are available
		if (!this.hasPackages && this.currentStep === 'color') {
			return this.stepConfig.steps[this.currentStepIdx + 1].nextPath;
		} else if (this.currentStepObj && this.currentStepObj.nextPath) {
			return this.currentStepObj.nextPath;
		}

		return this.stepConfig.rootPath;
	}

	getPreviousStep() {
		const prevStepIdx = this.currentStepIdx - 2;
		const prevStepObj = this.stepConfig.steps[prevStepIdx];

		// reverse 2 screens if this is form and no packages are available
		if (!this.hasPackages && this.currentStep === 'form') {
			return this.stepConfig.steps[this.currentStepIdx - 3].nextPath;
		} else if (prevStepObj && prevStepObj.nextPath) {
			return prevStepObj.nextPath;
		}

		return this.stepConfig.rootPath;
	}

	getCurrentStepObj() {
		return this.currentStepObj;
	}

	getCurrentStepNum() {
		return this.currentStepNum;
	}

	getProgressInfo() {
		const stepsLength = this.stepConfig.steps.length;
		const progressLabel =
			this.currentStepNum === stepsLength
				? `${this.labels.get('COMPLETE')}!`
				: `${this.labels.get('YOUR_PROGRESS')}`;
		const progressComplete = Math.floor(
			(100 / stepsLength) * this.currentStepNum
		);

		return {
			progressLabel,
			progressComplete
		};
	}

	getRootPath() {
		return this.stepConfig.rootPath;
	}

	getWidgetClasses() {
		const showVehicleCardClass = this.isDesktop ? 'w-50 px-6' : 'w-100';
		const mainHeadingClass = this.isDesktop ? 'display-4' : 'display-3';
		let stepHeadingClass = this.isDesktop ? 'w-50' : '';

		if (this.currentStep === 'make' || this.currentStep === 'model') {
			stepHeadingClass = '';
		}

		return {
			showVehicleCardClass,
			mainHeadingClass,
			stepHeadingClass
		};
	}

	setLsVehicleConfig() {
		if (typeof window !== 'undefined') {
			this.lsVehicleConfig = JSON.parse(
				window.localStorage.getItem('vehicleConfiguration')
			);
		}
	}

	resetLsVehicleConfig() {
		if (typeof window !== 'undefined') {
			const ls = window.localStorage;
			// reset vehicle config in local storage if we're on first step
			if (ls.getItem('vehicleConfiguration') !== null) {
				ls.removeItem('vehicleConfiguration');
			}
			this.setLsVehicleConfig();
		}
	}

	updateLsVehicleConfig() {
		// only attempt window access if we're on the browser
		if (typeof window !== 'undefined') {
			window.localStorage.setItem(
				'vehicleConfiguration',
				JSON.stringify(this.state?.vehicleConfiguration)
			);
		}
	}

	getLsVehicleConfig() {
		return this.lsVehicleConfig;
	}

	showTray() {
		return (
			this.currentStepObj.showVehicleCard &&
			this.currentStepObj.useTray &&
			!this.isDesktop
		);
	}

	showVehicleCard() {
		return (
			this.currentStepObj.showVehicleCard &&
			(this.isDesktop || !this.currentStepObj.useTray)
		);
	}
}

export default new StepController();
